// src/config/printDefaults.js
//
// The print configuration a book starts from, shared by the /quote estimator
// and the print intake's book specs so the two can never open on different
// books. Moved here from QuotePage.jsx unchanged.
//
// Option ids the backend ships by default. Only used to pick an opening
// configuration and to power "Reset options" — anything not present in the
// fetched pricing is dropped by whoever reads this.
export const DEFAULT_SELECTIONS = {
  quantity: 100,
  pages: 200,
  print_type: 'bw',
  paper_type: 'bond_75',
  size: 'half_letter',
  cover_type: 'softcover',
  lamination: 'none',
  binding: 'perfect',
  production_time: 'standard',
};
